import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
// styles
import { Container, Copyright } from './styles';

// ----------------------------------------------------------------------

export default function Layout() {
  const location  = useLocation();

  useEffect(() => {
    if ( location.state?.submit ) {
      const handleEvent = () => window.history.pushState(null, '', window.location.href);
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handleEvent);
      return () => window.removeEventListener('popstate', handleEvent);
    }
  }, [location]);

  return (
    <Container>
      <Outlet />
      <Copyright>©Water Eyes Corp. All Rights Reserved.</Copyright>
    </Container>
  );
}